import { createContext } from "react";
import { AlertModalProps } from "./types";

interface AlertModalContextData {
  openAlertModal: (params: AlertModalProps) => void;
}

export const AlertModalContext = createContext({} as AlertModalContextData);
